// extracted by mini-css-extract-plugin
var _1 = "cardTitle__Wy_Ua";
var _2 = "main__vEOkR";
var _3 = "row__CeaVz";
var _4 = "section__IpirD";
export { _1 as "cardTitle", _2 as "main", _3 as "row", _4 as "section" }
export default { "cardTitle": _1, "main": _2, "row": _3, "section": _4 }
